import { Box, Button, Typography } from '@material-ui/core';

const PaymentMethodButtonAction = ({
  classes,
  isPaymentTemplate,
  isChangeClicked,
  paymentMethodNode,
  handleEditClick,
  isPaymentReady,
  editCardDetailsLabel,
  isWallet,
}) => {
  const getJustifyContent = isWallet ? 'end' : 'center';
  return (
    <Box>
      {!isPaymentTemplate && (
        <Button
          disableRipple
          disableFocusRipple
          size="small"
          data-testid="payment-method-list-edit"
          onClick={() => {
            handleEditClick(paymentMethodNode);
          }}
          style={{
            backgroundColor: 'unset',
            padding: 0,
            justifyContent: getJustifyContent,
          }}
          disabled={!isPaymentReady}
        >
          <Typography
            variant="h6"
            style={{ fontSize: '14px' }}
            className={`${classes.changeButtonNode}`}
          >
            {editCardDetailsLabel}
          </Typography>
        </Button>
      )}
      {isPaymentTemplate && isChangeClicked && (
        <Button
          disableRipple
          disableFocusRipple
          size="small"
          data-testid="payment-method-list-edit"
          onClick={() => {
            handleEditClick(paymentMethodNode);
          }}
          style={{
            backgroundColor: 'unset',
            padding: 0,
            justifyContent: getJustifyContent,
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: '14px' }}
            className={`${classes.changeButtonNode}`}
          >
            {editCardDetailsLabel}
          </Typography>
        </Button>
      )}
    </Box>
  );
};

export default PaymentMethodButtonAction;
